/* global variation_types, translates */
var slickInstance;

App.prototype.buildProductFeaturesModal = function (data, productUid) {
    var modal = $('.feature-selection-modal'),
        slickSlider = modal.find('.product-detail-slider'),
        submitButton = modal.find('button[type=submit]'),
        rating = modal.find('.rating'),
    minimumOrder = [], maximumOrder = [];

    if (rating.length){
        rating.html('');
        const is_comments_hidden = data.parent ? data.parent.is_comments_hidden : data.is_comments_hidden;
        if (!is_comments_hidden){
            const $comment_count = data.parent ? data.parent.comments_count : data.comments_count;
            const $comment_rating = data.parent ? data.parent.comments_sum_rating : data.comments_sum_rating;
            let $points = 0;
            let rating_html = `<a href="${data.url}#comments-${productUid}" onclick="location.href = '${data.url}?v=d#comments-${productUid}'" class="d-flex align-items-center text-muted text-decoration-none" style="gap: 7px;font-size:80%;line-height: 2.5">`;
            if (!$comment_count || !$comment_rating){
                rating_html += `<svg width="15" height="15" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                          <path class="star-shape" d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.173L12 18.896l-7.336 3.975 1.402-8.173L.132 9.21l8.2-1.192L12 .587z" stroke="currentColor" stroke-width="0.5" />
                      </svg> `;
            }
            if (!$comment_count){
                rating_html += `${translates.no_comment_yet}`;
            }else{
                if ($comment_rating){
                    $points = ($comment_rating / $comment_count).toFixed(2);

                    rating_html += `<div class="d-flex">
                          <svg width="15" height="15" viewBox="0 0 24 24" ${$points > 0 ? 'color="#ffc107" fill="#ffc107"' : 'fill="none"'} xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                              <path class="star-shape" d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.173L12 18.896l-7.336 3.975 1.402-8.173L.132 9.21l8.2-1.192L12 .587z" stroke="currentColor" stroke-width="0.5" />
                          </svg>
                          <svg width="15" height="15" viewBox="0 0 24 24" ${$points > 1 ? 'color="#ffc107" fill="#ffc107"' : 'fill="none"'} xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                              <path class="star-shape" d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.173L12 18.896l-7.336 3.975 1.402-8.173L.132 9.21l8.2-1.192L12 .587z" stroke="currentColor" stroke-width="0.5" />
                          </svg>
                          <svg width="15" height="15" viewBox="0 0 24 24" ${$points > 2 ? 'color="#ffc107" fill="#ffc107"' : 'fill="none"'} xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                              <path class="star-shape" d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.173L12 18.896l-7.336 3.975 1.402-8.173L.132 9.21l8.2-1.192L12 .587z" stroke="currentColor" stroke-width="0.5" />
                          </svg>
                          <svg width="15" height="15" viewBox="0 0 24 24" ${$points > 3 ? 'color="#ffc107" fill="#ffc107"' : 'fill="none"'} xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                              <path class="star-shape" d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.173L12 18.896l-7.336 3.975 1.402-8.173L.132 9.21l8.2-1.192L12 .587z" stroke="currentColor" stroke-width="0.5" />
                          </svg>
                          <svg width="15" height="15" viewBox="0 0 24 24" ${$points > 4 ? 'color="#ffc107" fill="#ffc107"' : 'fill="none"'} xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
                              <path class="star-shape" d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.173L12 18.896l-7.336 3.975 1.402-8.173L.132 9.21l8.2-1.192L12 .587z" stroke="currentColor" stroke-width="0.5" />
                          </svg>
                      </div>
                      - `;
                }
                rating_html += `${$comment_count} ${translates.comment}`;
            }
            rating_html += '</a>';
            rating.html(rating_html);
        }
    }

    modal.find('h4').text(App.prototype.translateAttribute(data.name));
    modal.find('.brand-label').text(data.brand ? data.brand.name : '');
    modal.find('.description').html(App.prototype.translateAttribute(data.description) || '');
    if (!data.is_price_visible){
        modal.find('.price').html('');
        modal.find('.price_tax_info').html('');
    }else{
        let price = modal.find('.price_tax_info').length ? data.prices_without_tax['price'] : data.price;

        modal.find('.price').html(App.prototype.currencyFormat(price) + ' ' + translates.currency_code);

        if (modal.find('.price_tax_info').length){
            modal.find('.price_tax_info').html(`(${App.prototype.currencyFormat(data.prices_without_tax['price_tax'])} ${translates.currency_code} KDV %${data.prices_without_tax['tax_rate']} )`);
        }
    }

    if (data.is_price_visible){
        modal.find('.product-actions').removeClass('d-none');
        modal.find('button[type=submit]').removeClass('d-none');
    }else{
        modal.find('.product-actions').addClass('d-none');
        modal.find('button[type=submit]').addClass('d-none');
    }

    if (data.is_price_hidden_from_guest){
        modal.find('.price-is-hidden-message').removeClass('d-none');
    }else{
        modal.find('.price-is-hidden-message').addClass('d-none');
    }

    var el_getOfferModalButton = $('[data-show-product-get-offer-modal]');
    if(data.is_product_get_offer_available){
        el_getOfferModalButton.removeClass('d-none');

        el_getOfferModalButton
            .attr('data-show-product-get-offer-modal', data.unique_id)
            .attr('data-product-name', App.prototype.translateAttribute(data.name));
    }else{
        el_getOfferModalButton.addClass('d-none');
    }

    if (data.stock){
        minimumOrder.push(data.stock);
        maximumOrder.push(data.stock);
    }

    /*if (data.stock_minimum_order){
        minimumOrder.push(data.stock_minimum_order);

        minimumOrder = Math.min(...minimumOrder);

        modal.find('.count').html(minimumOrder);
        modal.find('.quantity-input').val(minimumOrder);

        modal.find('.count').attr('data-minimum', minimumOrder);
        modal.find('.quantity-input').attr('data-minimum', minimumOrder);
    }else{*/
        modal.find('.count').val(1);
        modal.find('.quantity-input').val(1);
    //}

    if (data.stock_maximum_order){
        maximumOrder.push(data.stock_maximum_order);

        maximumOrder = Math.min(...maximumOrder);

        modal.find('.count').attr('data-maximum', maximumOrder);
        modal.find('.quantity-input').attr('data-maximum', maximumOrder);

    }

    if (slickInstance) {

        slickInstance.slick('unslick');

    }

    if (data.images) {

        if (data.images.length) {
            var slidesHtml = '';

            data.images.forEach(function (item) {
                slidesHtml += '<div class="slide"><a href="' + item.url + '" data-fancybox="gallery"><img src="' + item.url + '" alt="' + App.prototype.translateAttribute(data.name) + '"><span class="enlarge-handle"><img src="/assets/consumer/default/img/icons/search.svg" alt=""></span></a></div>';
            });

            modal.find('.product-detail-slider').html(slidesHtml);
        }else{
            var placeholder = '<div class="slide"><div class="image-placeholder-for-slider"><span>'+translates.product_no_image+'</span></div></div>';

            modal.find('.product-detail-slider').html(placeholder);
        }
    }

    modal.find('#productDescriptions').html('');

    if (typeof data.product_descriptions !== 'undefined'){

        for (const productDescriptionsKey in data.product_descriptions) {

            modal.find('#productDescriptions').append(data.product_descriptions[productDescriptionsKey].text);

        }

    }

    modal.find('#campaignMessage').html('');

    if (data.campaign_message){

        modal.find('#campaignMessage').html(`<div class="alert alert-warning">${data.campaign_message}</div>`);

    }

    var features = data.features;
    var selectionsHolder = modal.find('.feature-selections');

    selectionsHolder.empty();

    App.prototype.selectedProductUi = productUid;

    modal.find('.product-uid-input').val(productUid);

    features.forEach(function (item) {

        if (item.type === "choose_one") {
            App.prototype.selectedProductType = "choose_one";
            App.prototype.buildSelect(item, selectionsHolder);
        } else if (item.type === "multiple") {
            App.prototype.selectedProductType = "multiple";
            App.prototype.buildCheckbox(item, selectionsHolder);
        }

    });

    if (data.parent_id === null){

        var variation_tree = data.variation_tree;
        var variantsHolder = modal.find('.variations');
        variantsHolder.empty();

        App.prototype.buildVariationTree(variantsHolder, variation_tree, data);

    }

    var orderInputs = data.product_order_inputs;
    var orderInputsHolder = modal.find('.order-inputs');
    orderInputsHolder.empty();

    orderInputs.forEach(function (item) {

        App.prototype.buildOrderInput(item, orderInputsHolder);

    });

    setTimeout(function(){
        slickInstance = slickSlider.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            slide: '.slide',
            arrows: false,
            dots: true,
        });
    }, 150)

    var el_whatsapp_input = modal.find('.send-with-whatsapp [data-first-part]');

    if (el_whatsapp_input.length){
        var firstText = el_whatsapp_input.data('firstPart');

        el_whatsapp_input.val(firstText + ' ' + data.url);
    }

    if (!modal.hasClass("bound")){
        modal.addClass("bound");
        modal.on('hidden.bs.modal', function (e) {
            if (slickInstance){

                slickInstance.slick('unslick');

            }

            if (history.state) {
                history.back();
            }
        })

        window.onpopstate = function (event) {
            if (modal.hasClass("show")) {
                modal.modal("hide");
            }
        };
    }

    if (data.is_active && data.stock === 0){

        submitButton.attr('data-out-of-stock', true);

    }else{

        submitButton.removeAttr('data-out-of-stock', false);

    }

    if (data.is_active && data.stock !== 0){

        submitButton.prop("disabled", false);

    }else{

        submitButton.prop("disabled", true);

    }
}
